const SET_LOG_RESPONSE = (state, payload) => {
    state.log_response = '';
    state.log_response = payload;
}

const CLEAR_LOG_RESPONSE = (state) => {
    state.log_response = '';
}

const CLEAR_STATES = (state) => {
    state.log_response = '';
}

export {
    SET_LOG_RESPONSE,
    CLEAR_LOG_RESPONSE,
    CLEAR_STATES
}
